import * as React from 'react';
import Anchor from '@telia-front/anchor';
export default class PaginationNumber extends React.Component {
    BEM() {
        const classArray = ['pagination-number'];
        if (this.props.color) {
            classArray.push('pagination-number--' + this.props.color);
        }
        if (this.props.position) {
            classArray.push('pagination-number--' + this.props.position);
        }
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    renderText(text) {
        return React.createElement("p", { className: "pagination-number__text" }, text);
    }
    renderItem(index, item) {
        let classNames = 'pagination-number__item';
        if (item.current) {
            classNames += ' is-active';
        }
        return (React.createElement("li", { className: classNames, key: index },
            React.createElement(Anchor, Object.assign({ isUnderlined: false }, item, { className: "pagination-number__link" }), item.label)));
    }
    renderItems() {
        const items = this.props.items.map((item, i) => {
            return this.renderItem(i, item);
        });
        return React.createElement("ul", { className: "pagination-number__items" }, items);
    }
    render() {
        return (React.createElement("div", { className: this.BEM() },
            this.props.textLeft && this.renderText(this.props.textLeft),
            this.props.items && this.renderItems(),
            this.props.textRight && this.renderText(this.props.textRight)));
    }
}
